export const skills = [
  "JavaScript (ES6)",
  "React",
  "Gatsby",
  "Express",
  "Python",
  "Axios",
  "TinyHTTP",
  "Figma",
  "Photoshop",
  "Needle",
  "Svelte",
  "HTML",
  "CSS",
  "Docker",
];

export const nav = [
  {
    name: "Home",
    to: "/",
  },
  {
    name: "About",
    to: "/about",
  },
  {
    name: "Projects",
    to: "/projects",
  },
  {
    name: "Posts",
    to: "/posts",
  },
];
